const gaId = process.env.VUE_APP_GA_ID_USER
export const config = (payload) => {
  if (!gaId || !gtag) return
  gtag('config', gaId, payload)
}

export const setUserProperties = (payload) => {
  if (!gaId || !gtag) return
  gtag('set', 'user_properties', payload)
}

export const set = (payload) => {
  if (!gaId || !gtag) return
  gtag('set', payload)
}

export const event = (name, payload) => {
  if (!gaId || !gtag) return
  gtag('event', name, payload)
}
